export enum Vertical {
	RESTAURANT = "RESTAURANT",
	EVENTS = "EVENTS",
}

export enum BusinessRegion {
	INDIA = "India",
	US = "United States",
}

export enum Vendor {
	SHIPROCKET = "SHIPROCKET",
	UBRYD = "UBRYD",
	SELF = "SELF",
	TEST = "TEST"
}